import React from 'react';
import AdminManagement from './AdminManagement';

export default function AdministrationAdvanced({ token, isDarkMode, companyId, effectiveRole }) {
  const card = isDarkMode ? '#111827' : '#ffffff';
  const text = isDarkMode ? '#f8fafc' : '#1f2937';
  const border = isDarkMode ? '#334155' : '#e2e8f0';

  return (
    <section style={{ background: card, color: text, padding: 20, borderRadius: 12, border: `1px solid ${border}`, marginBottom: 30 }}>
      <AdminManagement
        token={token}
        isDarkMode={isDarkMode}
        companyId={companyId}
        effectiveRole={effectiveRole}
      />
    </section>
  );
}
